import React, { Component } from 'react';

class CadastroTopico extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h4 className="card-title">TÓPICOS DISCUTIDOS</h4>
                </div>
                <div className="col-md-6 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.props.onAdicionarTopico}
                  >
                    Incluir Tópico
                  </button>
                </div>
              </div>
              {this.props.topicos.map(
                function(topico, i) {
                  return (
                    <div key={i} className="form-group row">
                      <div className="col-md-12">
                        <div className="input-group">
                          <textarea
                            rows="5"
                            placeholder="DESCRIÇÃO"
                            name="descricao"
                            className="form-control"
                            value={topico.descricao}
                            onChange={event => this.props.onAlterarTopico(i, event.target.value)}
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-xs btn-info"
                              type="button"
                              onClick={() => this.props.onRemoverTopico(i)}
                            >
                              x
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }.bind(this),
              )}
            </div>
            <span className="field-info">
              * Para vincular atividade/reunião ao paciente, digite o código/ID do Cismepar do
              paciente.
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroTopico;
